export default "__VITE_ASSET__CM30eI4M__"